import React, { useRef, useState } from 'react'
import { Dimensions, Modal, Pressable, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { DS } from '@/design-system'

const SCREEN_PADDING = 12
const ARROW_HALF = 5

interface TooltipProps {
  text: string
  children: React.ReactNode
}

export function Tooltip({ text, children }: TooltipProps) {
  const [visible, setVisible] = useState(false)
  const [anchorX, setAnchorX] = useState(0)
  const [bubbleTop, setBubbleTop] = useState(0)
  const [bubbleWidth, setBubbleWidth] = useState(0)
  const [ready, setReady] = useState(false)
  const triggerRef = useRef<View>(null)

  const screenWidth = Dimensions.get('window').width

  const handleOpen = () => {
    triggerRef.current?.measure((_x, _y, width, _height, pageX, pageY) => {
      setAnchorX(pageX + width / 2)
      setBubbleTop(pageY)
      setReady(false)
      setVisible(true)
    })
  }

  const clampedLeft =
    bubbleWidth > 0
      ? Math.max(SCREEN_PADDING, Math.min(anchorX - bubbleWidth / 2, screenWidth - bubbleWidth - SCREEN_PADDING))
      : anchorX

  const arrowLeft = Math.max(ARROW_HALF, anchorX - clampedLeft - ARROW_HALF)

  return (
    <>
      <Pressable ref={triggerRef} onPress={handleOpen} hitSlop={8}>
        {children}
      </Pressable>

      <Modal visible={visible} transparent animationType="none" onRequestClose={() => setVisible(false)}>
        <TouchableOpacity style={styles.overlay} activeOpacity={1} onPress={() => setVisible(false)}>
          <View
            style={[styles.bubble, { left: clampedLeft, top: bubbleTop, opacity: ready ? 1 : 0 }]}
            onLayout={(e) => {
              setBubbleWidth(e.nativeEvent.layout.width)
              setReady(true)
            }}
          >
            <Text style={styles.text}>{text}</Text>
            <View style={[styles.arrow, { left: arrowLeft }]} />
          </View>
        </TouchableOpacity>
      </Modal>
    </>
  )
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1
  },
  bubble: {
    position: 'absolute',
    transform: [{ translateY: '-100%' }, { translateY: -8 }],
    backgroundColor: DS.palette['Global/Black'],
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 12,
    maxWidth: 200
  },
  text: {
    color: DS.palette['Global/White'],
    fontSize: 12,
    lineHeight: 16
  },
  arrow: {
    position: 'absolute',
    bottom: -5,
    width: 10,
    height: 10,
    backgroundColor: DS.palette['Global/Black'],
    transform: [{ rotate: '45deg' }]
  }
})
